import { EmptyStateActions } from "./empty-state-actions.component";
import { EmptyStateDescription } from "./empty-state-description.component";
import { EmptyStateHeading } from "./empty-state-heading.component";
import { EmptyStateImage } from "./empty-state-image.component";
import { EmptyStateWrapper } from "./empty-state-wrapper.component";
import { EmptyStateProvider } from "./providers";

import type { EmptyStateProps } from "./empty-state.types";

import styles from "./empty-state.module.css";

export function EmptyState({
  children,
  className = "",
  dataQA,
  variant = "wide",
  dataTestId,
  ...props
}: Readonly<EmptyStateProps>) {
  return (
    <div
      className={`${styles.Container} ${styles[variant]} ${className}`}
      data-qa={dataQA}
      data-testid={dataTestId}
      {...props}
    >
      <EmptyStateProvider size={variant}>{children}</EmptyStateProvider>
    </div>
  );
}

export namespace EmptyState {
  export const Actions = EmptyStateActions;
  export const Description = EmptyStateDescription;
  export const Heading = EmptyStateHeading;
  export const Image = EmptyStateImage;
  export const Wrapper = EmptyStateWrapper;
}
